// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__5Q1x1","title":"Badge_title__6RU0I","small":"Badge_small__p-9mS"};